module.exports = __webpack_public_path__ + "static/media/webBlueOutline.6de32ea4.svg";